/** **************************** Import Libs ****************************** */
import { combineReducers } from "redux";
/** **************************** Import Reducers ****************************** */
import {
  //   sideBarReducer,
  //   NavBarReducer,
  profileDropDownReducer,
  DarkThemeReducer,
  NotificationReducer,
  //   LedgerReducer,
  //   FlaggedReducer,
  //   GameUserReducer,
  //   MegaJacpotResultReducer,
  //   InstantJacpotResultReducer,
  //   RoulottoJacpotResultReducer,
  //   MegaJacpotStatsReducer,
  //   loginReducer,
  //   SystemUserReducer
} from "./reducers";
import TimeLineReducer from "./reducers/updateTimeline.reducer";
import globalDialerReducer from "./reducers/globalDialerReducer";

const rootReducer = combineReducers({
  // login:loginReducer,
  // SideBar: sideBarReducer,
  profileDropdown: profileDropDownReducer,
  NotificationReducer: NotificationReducer,
  DarkThemeReducer: DarkThemeReducer,
  TimeLineReducer: TimeLineReducer,
  globalDialer: globalDialerReducer,
  // NavbarReduce: NavBarReducer,
  // ledgerReducer: LedgerReducer,
  // flaggedReducer: FlaggedReducer,
  // gameUser: GameUserReducer,
  // MegaResult: MegaJacpotResultReducer,
  // InstantResult: InstantJacpotResultReducer,
  // RoulottoResult: RoulottoJacpotResultReducer,
  // Stats: MegaJacpotStatsReducer,
  // DepositReducer: DepositReducer,
  // AdminUser:SystemUserReducer,
});

export default rootReducer;
